// extracted by mini-css-extract-plugin
export default {"btop":"_5ada56aff4 _13f975fce2 _759822c009","icon":"_43ecd7c2c0 _4409c0b3d7","btoppink":"f1e0ff1bc3 bde656b5a1"};